import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {colorForMedianRtt, TRAFFIC_OVERVIEW_NO_DATA_COLOR} from "../../helpers/traffic_overview";

export class ShaperTrafficOverviewGuide extends BaseDashlet {
    title() {
        return "Traffic Overview Guide";
    }

    tooltip() {
        return "<h5>Traffic Overview</h5><p>Explains what the volume and colors mean in the traffic overview cards.</p>";
    }

    channelRequests() {
        return [];
    }

    buildContainer() {
        const base = super.buildContainer();
        const body = document.createElement("div");
        body.classList.add("px-3", "pb-3", "small");
        const badge = (label, color, darkText = true) =>
            `<span class="badge ${darkText ? "text-dark" : "text-light"}" style="background:${color};">${label}</span>`;
        body.innerHTML = `
            <div class="row g-3 align-items-start">
                <div class="col-lg-4">
                    <div class="fw-semibold text-uppercase text-muted mb-1">Direction</div>
                    <div class="mb-1"><span class="fw-semibold text-success">Download</span>: traffic coming into this shaper.</div>
                    <div><span class="fw-semibold text-info">Upload</span>: traffic leaving this shaper.</div>
                </div>
                <div class="col-lg-4">
                    <div class="fw-semibold text-uppercase text-muted mb-1">Volume</div>
                    <div>Wider flows and larger map dots mean more traffic over the selected time period.</div>
                    <div class="text-muted mt-1">The two live charts still show current traffic only.</div>
                </div>
                <div class="col-lg-4">
                    <div class="fw-semibold text-uppercase text-muted mb-1">Color</div>
                    <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
                        ${badge("Healthy RTT", colorForMedianRtt(20))}
                        ${badge("Watch RTT", colorForMedianRtt(90))}
                        ${badge("Needs attention", colorForMedianRtt(160))}
                        ${badge("No RTT data", TRAFFIC_OVERVIEW_NO_DATA_COLOR, false)}
                    </div>
                    <div>Colors show median RTT over the selected time period, not traffic size.</div>
                </div>
            </div>
        `;
        base.appendChild(body);
        return base;
    }
}
